/**
 * @Author: Nenad Brcic
 * @Date: 31.05.16
 * @Email: neno@neno.ch
 */

import React, {Component} from 'react';
import CSSModules from 'react-css-modules';
import About from '../../About';
import Icon from '../../shared/Icon';
import styles from './Information.scss';
import localize from '../../../localize';
import { getCurrentLanguage } from '../../../localData';


class Information extends Component {
    constructor(props) {
        super(props);
        this.toggleInformation = this.toggleInformation.bind(this);
    }

    getAboutTexts() {
        let aboutTexts = {};
        if(!!this.props.store.staticTexts && this.props.store.staticTexts.edges.length) {
            for(let i = 0; i < this.props.store.staticTexts.edges.length; i++) {
                const edge = this.props.store.staticTexts.edges[i];
                if (edge.node.StaType === 'Einführungstext') {
                    aboutTexts.about = <About key={ edge.node.id } staticText={ edge.node }/>;
                } else if (edge.node.StaType === 'Impressum') {
                    aboutTexts.impressum = <About key={ edge.node.id } staticText={ edge.node }/>;
                }
            }
        }
        return !!aboutTexts ? [aboutTexts.about, aboutTexts.impressum] : [];
    }

    toggleInformation() {
        this.props.relay.setVariables({
            isInformationVisible: !this.props.relay.variables.isInformationVisible
        });
    }

    render() {
        const isInformationVisible = this.props.relay.variables.isInformationVisible;
        const icon = isInformationVisible ? "Vitra_Up.svg" : "Vitra_Down.svg";

        function l(key) {
            const str = `${getCurrentLanguage()}.components.Navigation.${key}`;
            return localize(str);
        }

        const about = this.getAboutTexts();

        return (
            <div styleName="container">
                <button styleName="toggle" onClick={() => this.toggleInformation()}>
                    { l("information") }
                    <Icon styleName="icon" icon={icon} />
                </button>

                <div styleName="information" className={ isInformationVisible ? 'is-visible' : null }>
                    { about }
                </div>
            </div>
        )
    }
}

export default CSSModules(Information, styles);


// WEBPACK FOOTER //
// ./app/components/Main/Information/Information.jsx